
/**
 * Classe responsável por manter a Permissão de Menus do usuário.
 */
export class AgroPermissionModel<T> {

    aplicat : string;
    form : string;
    child : string;
    
    menu : T;

    constructor() {}

}